import { render } from "./ContentAlertModal.vue?vue&type=template&id=8d9e4a76&scoped=true&ts=true"
import script from "./ContentAlertModal.vue?vue&type=script&lang=ts"
export * from "./ContentAlertModal.vue?vue&type=script&lang=ts"

import "./ContentAlertModal.vue?vue&type=style&index=0&id=8d9e4a76&scoped=true&lang=css"

import exportComponent from "/app/purple__bee/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d9e4a76"]])

export default __exports__